<div class="d-grid">
  <span
    [enableTooltip]="!documentDescription || documentCodeIds.length == 0"
    [certTooltip]="'Select document code(s) and enter a description to scan'"
  >
    <button
      class="btn btn-block btn-outline-primary px-5"
      (click)="launch()"
      [disabled]="!documentDescription || documentCodeIds.length == 0"
    >
      Launch Scanner
    </button>
  </span>
</div>
<div id="formFileHelp" class="form-text">Click the button to launch the scanner interface.</div>
